// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".seal-line-area[data-v-87045ce4]{position:absolute;left:-90px;height:1110px;background-color:#fff;top:0}", ""]);
// Exports
module.exports = exports;
